import React from "react";
import { Link } from "react-router-dom";
import { MarketingLayout } from "../enterprise2/MarketingLayout";
import { NAV, ROADMAP_LABEL, ROADMAP_TO } from "../../data/machines2";

export function M2Layout({ children, active, title, description }) {
  return (
    <MarketingLayout active={active} title={title} description={description} nav={NAV} side="machines">
      {children}
    </MarketingLayout>
  );
}

export function SectionIndex({ n, label }) {
  return (
    <div className="e2-idx" data-testid={`m2-idx-${n}`}>
      <span className="e2-idx-num">{n}</span>
      <span className="e2-idx-rule" />
      <span className="e2-idx-label">{label}</span>
    </div>
  );
}

export function FigCap({ n, label, style }) {
  return (
    <div className="e2-fig-cap code" style={style}>
      FIG.{n} &nbsp;·&nbsp; {label}
    </div>
  );
}

export const Arrow = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Page hero: centred Apple composition shared by every Machines 2 sub-page.
export function PageHero({ eyebrow, title, sub, testId, children }) {
  return (
    <section className="e2-hero-banner m2-page-hero" data-testid={testId}>
      <div className="e2-hero-banner-grid">
        <div className="e2-hero-banner-lead">
          <div className="e2-eyebrow">{eyebrow}</div>
          <h1 className="e2-hero-banner-title" data-testid={`${testId}-title`}>{title}</h1>
          {sub && <p className="e2-hero-banner-subtitle">{sub}</p>}
          <div className="e2-hero-banner-actions">
            <Link to={ROADMAP_TO} className="e2-btn e2-btn-primary" data-testid={`${testId}-cta`}>{ROADMAP_LABEL}</Link>
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}

// Closing statement band: Deep Navy to Midnight Forest, centred.
export function CTABand({ line, sub, testId = "m2-cta-band" }) {
  return (
    <section className="e2-cband" data-testid={testId} style={{ marginTop: 40 }}>
      <div className="e2-cband-statement">
        <div className="e2-cband-statement-inner">
          <div className="e2-cband-eyebrow" style={{ color: "#6AA1A3" }}>Crowther for Machines</div>
          <h2 className="e2-cband-statement-title">{line}</h2>
          {sub && <p className="e2-cband-statement-sub">{sub}</p>}
          <div className="e2-cband-statement-actions">
            <Link to={ROADMAP_TO} className="e2-cband-btn e2-cband-btn-primary" data-testid={`${testId}-pill`}>{ROADMAP_LABEL} <Arrow /></Link>
            <Link to="/machines-2/contact" className="e2-cband-btn e2-cband-btn-ghost" data-testid={`${testId}-contact`}>Or talk to us directly</Link>
          </div>
        </div>
      </div>
    </section>
  );
}

// Product figure: a quiet dark panel with dot grid, product name and its three verbs.
export function ProductFigure({ product, tone = "forest" }) {
  return (
    <div className={`m2-figure ${tone}`} data-testid={`m2-figure-${product.key}`} aria-hidden>
      <div className="m2-figure-head">
        <span>{product.n} &nbsp;·&nbsp; {product.name.toUpperCase()}</span>
        <span>{product.meta[0]}</span>
      </div>
      <div className="m2-figure-body">
        {product.keywords.map((k) => (
          <span key={k} className="m2-figure-chip">{k}</span>
        ))}
      </div>
      <div className="m2-figure-foot">
        <span>■ {product.name.toUpperCase()}</span>
        <span>{product.meta[1]}</span>
      </div>
    </div>
  );
}
